export default {
	recommendedLength: 15,
	percentages: {
		slightlyTooMany: 20,
		farTooMany: 25,
	},
};
